import { z } from "zod";

/**
 * Shared shape for the primary location, used both when creating a store
 * (docs/api-design.md §10.1) and `PUT /stores/:storeId/location`
 * (docs/business-rules.md §4.2: 1 Store = 1 Primary Location in MVP).
 *
 * Map coordinates are optional — sellers may save an address without pinning
 * a point on OpenStreetMap.
 */
function optionalCoordinate(min: number, max: number) {
  return z.preprocess((value) => {
    if (value === "" || value === null || value === undefined) {
      return undefined;
    }
    if (typeof value === "number" && Number.isNaN(value)) {
      return undefined;
    }
    return value;
  }, z.number().min(min).max(max).optional());
}

export const storeLocationSchema = z.object({
  name: z.string().trim().max(150).optional(),
  addressLine: z.string().trim().min(1),
  subdistrict: z.string().trim().max(100).optional(),
  district: z.string().trim().max(100).optional(),
  province: z.string().trim().max(100).optional(),
  postalCode: z.string().trim().max(10).optional(),
  latitude: optionalCoordinate(-90, 90),
  longitude: optionalCoordinate(-180, 180),
  pickupInstruction: z.string().trim().max(2000).optional(),
});
export type StoreLocationInput = z.infer<typeof storeLocationSchema>;

export const upsertStoreLocationSchema = storeLocationSchema;
export type UpsertStoreLocationInput = z.infer<typeof upsertStoreLocationSchema>;
